import { render, staticRenderFns } from "./WeightEstimate.vue?vue&type=template&id=0677009d&scoped=true"
import script from "./WeightEstimate.vue?vue&type=script&lang=js"
export * from "./WeightEstimate.vue?vue&type=script&lang=js"
import style0 from "./WeightEstimate.vue?vue&type=style&index=0&id=0677009d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0677009d",
  null
  
)

export default component.exports